import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './CommunityCard.css';
import CommunityIcon from './CommunityIcon';

/**
 * CommunityCard Component
 * Displays a community preview card with thumbnail, name, description, and subscriber count
 *
 * @param {string} name - The community name
 * @param {string} slug - The community slug for URL routing
 * @param {string} description - Short description of the community
 * @param {number} memberCount - Number of subscribers/members
 * @param {string} thumbnail - URL for the community thumbnail image
 */
function CommunityCard({
    name,
    slug,
    description,
    memberCount = 0,
    thumbnail = '',
}) {
    return (
        <Card
            as={Link}
            to={`/communities/${slug}`}
            className="community-card h-100 text-decoration-none"
        >
            <Card.Body className="d-flex align-items-center gap-3 p-3">
                <div className="community-thumbnail-wrapper flex-shrink-0">
                    {thumbnail ? (
                        <img
                            src={thumbnail}
                            alt={`${name} thumbnail`}
                            className="community-thumbnail"
                        />
                    ) : (
                        <CommunityIcon
                            name={name}
                            className="community-thumbnail"
                        />
                    )}
                </div>
                <div className="community-info flex-grow-1 min-width-0">
                    <Card.Title className="community-name h6 mb-1">
                        {name}
                    </Card.Title>
                    <Card.Text className="community-card-description small mb-2">
                        {description}
                    </Card.Text>
                    <Card.Text className="community-subscribers small mb-0">
                        {memberCount} Subscribers
                    </Card.Text>
                </div>
            </Card.Body>
        </Card>
    );
}

CommunityCard.propTypes = {
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    memberCount: PropTypes.number,
    thumbnail: PropTypes.string,
};

export default CommunityCard;
